import { useApiClient } from '@chilipiper/api-client/src/context'
import { ScheduleMeetingRequestPublic } from '@chilipiper/api-client/src/handoff'
import {
  OneClickInitializationRequest,
  ScheduleMeetingRequestV2,
} from '@chilipiper/api-client/src/team-scheduling'
import { useMutation } from '@tanstack/react-query'

export const useBookMeeting = (tenantId: string) => {
  const { teamSchedulingV2 } = useApiClient()

  return useMutation({
    mutationFn: (payload: ScheduleMeetingRequestV2) => {
      return teamSchedulingV2.scheduleAMeetingV2GuestEndpoint(tenantId, payload)
    },
  })
}

export const useInitializeOneClick = (tenantId: string) => {
  const { teamScheduling } = useApiClient()

  return useMutation({
    mutationFn: async (payload: OneClickInitializationRequest) => {
      const response = await teamScheduling.initializeOneClickSchedulingFormGuestEndpoint(
        tenantId,
        payload
      )

      return response
    },
  })
}

export const useHandoffBooking = (tenantId: string) => {
  const { handoff } = useApiClient()

  return useMutation({
    mutationFn: ({
      routingId,
      params,
    }: {
      routingId: string
      params: ScheduleMeetingRequestPublic
    }) => {
      return handoff.scheduleMeetingWithinAParticularRoutingIdPublic(tenantId, routingId, params)
    },
  })
}
